import { CurrencyrateErrorFragment } from "@saleor/fragments/types/CurrencyrateErrorFragment";
import { CurrencyrateErrorCode } from "@saleor/types/globalTypes";
import { defineMessages, IntlShape } from "react-intl";

import commonErrorMessages from "./common";

const messages = defineMessages({
  alreadyExists: {
    defaultMessage: "A currencyrate with this SLUG already exists"
  },
  not_found: {
    defaultMessage:
      "The Slug value you entered does not conform to the International Monetary Abbreviation Specification"
  },
  required: {
    defaultMessage: "The field must have a value"
  },
  unique: {
    defaultMessage: "This Slug has been associated with other exchange rates"
  }
});

function getCurrencyrateErrorMessage(
  err: Omit<CurrencyrateErrorFragment, "__typename"> | undefined,
  intl: IntlShape
): string {
  if (err) {
    switch (err.code) {
      case CurrencyrateErrorCode.ALREADY_EXISTS:
        return intl.formatMessage(messages.alreadyExists);
      case CurrencyrateErrorCode.UNIQUE:
        return intl.formatMessage(messages.unique);
      case CurrencyrateErrorCode.REQUIRED:
        return intl.formatMessage(messages.required);
      case CurrencyrateErrorCode.NOT_FOUND:
        return intl.formatMessage(messages.not_found);
      default:
        return intl.formatMessage(commonErrorMessages.unknownError);
    }
  }
}

export default getCurrencyrateErrorMessage;
